import styled from 'styled-components'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Typography } from 'common/typography'
import Wrapper from 'common/wrapper'
import { PinkGradient } from 'home/platform'

const ProjectStudentsHeroStyled = styled.section`
  background: linear-gradient(180deg, #082054 1.47%, rgba(4, 0, 30, 0.9) 108.16%);
  text-align: center;
  padding-block-start: 90px;
  padding-block-end: 90px;
  h1 {
    max-width: 1100px;
    margin: 0 auto;
    ${PinkGradient}
  }
  p {
    margin: 48px auto;
  }
  .hero-container {
    margin: 0 auto;
    max-width: 600px;
  }
  .toggle {
    display: none;
  }
  .toggle-elements {
    display: flex;
    position: relative;
    background: var(--basePrimary);
    border-radius: 4px;
    cursor: pointer;
  }
  .background {
    background: var(--turquoise);
    border-radius: 4px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 50%;
    z-index: 1;
    transition: 0.2s ease-in;
    ${({ active }) => active && `
      right: 0;
      left: 50%;
    `}
  }
  .toggle-element {
    position: relative;
    font: var(--regularBold);
    flex: 1;
    text-align: center;
    padding: 9px 0;
    border-radius: 4px;
    z-index: 2;
    transition: 0.4s ease-in color;
    color: var(--baseSecondary);
    ${({ active }) => (active ? `
      &:last-of-type {
        color: var(--basePrimary);
      }
    ` : `
      &:first-of-type {
        color: var(--basePrimary);
      }
    `)}
  }
`

function ProjectStudentsHero({ title, description }) {
  const { pathname } = useRouter()

  return (
    <ProjectStudentsHeroStyled active={pathname === '/podium'}>
      <Wrapper maxWidth={1366}>
        <Typography as="h1" small="headline4" large="headline1">
          {title}
        </Typography>
        <div className="hero-container">
          <Typography>
            {description}
          </Typography>
          <div className="btns-container">
            <div className="toggle-elements">
              <Link href="/proyectos/estudiantes" className="toggle-element">
                Proyectos
              </Link>
              <div className="background" />
              <Link href="/podium" className="toggle-element">
                Podio
              </Link>
            </div>
          </div>
        </div>
      </Wrapper>
    </ProjectStudentsHeroStyled>
  )
}

export default ProjectStudentsHero
